import { FunctionalComponent } from 'preact'

export interface HeroImagePreviewProps {
  src: string
  dimentionLabel: string
}

export const HeroImagePreview: FunctionalComponent<HeroImagePreviewProps> = (props) => {
  const { src, dimentionLabel } = props
  return (
    <div className='hero-image-wrapper'>
      <img src={src} />
      <a target='_blank' rel='noreferrer' href={src} className='component-uploader__image-details'>
        {dimentionLabel} <i className='icon icon-external' />
      </a>
    </div>
  )
}
